import { PanelRightClose } from "lucide-react";

export let routes = [

  // organization
  { name: "/organization/switcher", action: "ORGANIZATION_ALL||Switch_Organization" },
  { name: "/organization/details", action: "ORGANIZATION_ALL||Switch_Organization" },
  { name: "/organization/profile", action: "ORGANIZATION_PROFILE_ALL" },
  { name: "/organization/application-access", action: "VIEW_ORGANIZATION_APPLICATION" },

  // employees
  { name: "/organization/employee/employee-details", action: "EMPLOYEE_VIEW_ALL" },
  { name: "/organization/employee/employee-details/add", action: "EMPLOYEE_ADD" },
  { name: "/organization/employee/employee-details/edit", action: "EMPLOYEE_EDIT" },




  // employee exits 
  { name: "/training-programs", action: "VIEW_TRAINING_PROGRAMS" },
  { name: "/training-programs/add", action: "ADD_TRAINING_PROGRAM" },
  { name: "/training-programs/edit", action: "EDIT_TRAINING_PROGRAM" },
  { name: "/training-programs/view", action: "VIEW_TRAINING_PROGRAM" },
  { name: "/training-programs/delete", action: "DELETE_TRAINING_PROGRAM" },

// employee records
  { name: "/training-programs-categories", action: "VIEW_TRAINING_PROGRAM_CATEGORIES" },
  { name: "/training-programs-categories/add", action: "ADD_TRAINING_PROGRAM_CATEGORY" },
  { name: "/training-programs-categories/edit", action: "EDIT_TRAINING_PROGRAM_CATEGORY" },
  { name: "/training-programs-categories/view", action: "VIEW_TRAINING_PROGRAM_CATEGORIES" },
  { name: "/training-programs-categories/delete", action: "DELETE_TRAINING_PROGRAM_CATEGORY" },

  { name: "/training-spaces", action: "VIEW_TRAINING_PROGRAMS" },
  { name: "/training-spaces/add", action: "ADD_TRAINING_PROGRAM" },
  { name: "/training-spaces/edit", action: "EDIT_TRAINING_PROGRAM" },
  { name: "/training-spaces/view", action: "VIEW_TRAINING_PROGRAMS" },
  { name: "/training-spaces/delete", action: "DELETE_TRAINING_PROGRAM" },
  { name: "/slot-availability", action: "VIEW_SLOT_AVALABILITY" },
  { name: "/trainer-slot-availability", action: "VIEW_TRAINER_SLOT_AVALABILITY" },

// functional role 
  { name: "/students", action: "VIEW_STUDENTS" },
  { name: "/students/add", action: "ADD_STUDENT" },
  { name: "/students/edit", action: "EDIT_STUDENT" },
  { name: "/students/view", action: "VIEW_STUDENTS" },
  { name: "/students/delete", action: "DELETE_STUDENT" },

  // employment stages 
  { name: "/students-fees", action: "VIEW_STUDENT_FEE" },
  { name: "/students-fees/add", action: "ADD_STUDENT_FEE" },
  { name: "/students-fees/edit", action: "EDIT_STUDENT_FEE" },
  { name: "/students-fees/view", action: "VIEW_STUDENT_FEE" },
  { name: "/students-fees/delete", action: "DELETE_STUDENT_FEE" },

// document types
  { name: "/leads", action: "VIEW_LEADS" },
  { name: "/leads/add", action: "ADD_LEAD" },
  { name: "/leads/edit", action: "EDIT_LEAD" },
  { name: "/leads/view", action: "VIEW_LEADS" },
  { name: "/leads/delete", action: "DELETE_LEAD" },

// document 
  { name: "/lead-stages", action: "VIEW_LEAD_STAGE" },
  { name: "/lead-stages/add", action: "ADD_LEAD_STAGE" },
  { name: "/lead-stages/edit", action: "EDIT_LEAD_STAGE" },
  { name: "/lead-stages/view", action: "VIEW_LEAD_STAGE" },
  { name: "/lead-stages/delete", action: "DELETE_LEAD_STAGE" },

  // skills category
  { name: "/lead-sources", action: "VIEW_LEAD_SOURCE" },
  { name: "/lead-sources/add", action: "ADD_LEAD_SOURCE" },
  { name: "/lead-sources/edit", action: "EDIT_LEAD_SOURCE" },
  { name: "/lead-sources/view", action: "VIEW_LEAD_SOURCE" },
  { name: "/lead-sources/delete", action: "DELETE_LEAD_SOURCE" },

  // skills category group
  { name: "/lead-activities", action: "VIEW_LEAD_ACTIVITY" },
  { name: "/lead-activities/add", action: "ADD_LEAD_ACTIVITY" },
  { name: "/lead-activities/edit", action: "EDIT_LEAD_ACTIVITY" },
  { name: "/lead-activities/view", action: "VIEW_LEAD_ACTIVITY" },
  { name: "/lead-activities/delete", action: "DELETE-LEAD_ACTIVITY" },

  // functional role skill
  { name: "/lead-contact-timings", action: "VIEW_LEAD_CONTACT_TIMINGS" },
  { name: "/lead-contact-timings/add", action: "ADD_LEAD_CONTACT_TIMING" },
  { name: "/lead-contact-timings/edit", action: "EDIT_LEAD_CONTACT_TIMING" },
  { name: "/lead-contact-timings/view", action: "VIEW_LEAD_CONTACT_TIMINGS" },
  { name: "/lead-contact-timings/delete", action: "DELETE_CONTACT_TIMING" },



  
  // functional role skill element
  { name: "/assesments", action: "VIEW_ASSESSMENTS" },
  { name: "/assesments/add", action: "ADD_ASSESSMENT" },
  { name: "/assesments/edit", action: "EDIT_ASSESSMENT" },
  { name: "/assesments/view", action: "VIEW_ASSESSMENTS" },
  { name: "/assesments/delete", action: "DELETE_ASSESSMENT" },

  // works shifts 
  { name: "/assesment-results", action: "VIEW_ASSESSMENT_RESULTS" },
  { name: "/assesment-results/add", action: "ADD_ASSESSMENT_RESULT" },
  { name: "/assesment-results/edit", action: "EDIT_ASSESSMENT_RESULT" },
  { name: "/assesment-results/view", action: "VIEW_ASSESSMENT_RESULTS" },
  { name: "/assesment-results/delete", action: "DELETE_ASSESSMENT_RESULT" },

// WORKSHIFT DAYS 
  { name: "/batches", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/student-batch-calendar", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batches/add", action: "ADD_BATCHES" },
  { name: "/batches/edit", action: "EDIT_BATCHES" },
  { name: "/batches/view", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batches/delete", action: "DELETE_BATCHES" },

  // batch trainers
  { name: "/batch-trainers", action: "VIEW_BATCHES" },
  { name: "/batch-trainers/add", action: "ADD_BATCHES" },
  { name: "/batch-trainers/edit", action: "EDIT_BATCHES" },
  { name: "/batch-trainers/view", action: "VIEW_BATCHES" },
  { name: "/batch-trainers/delete", action: "DELETE_BATCHES" },

  // work model days 
  { name: "/batch-classes", action: "VIEW_BATCH_CLASS||VIEW_SELF_BATCH_CLASSES" },
  { name: "/batch-classes/add", action: "ADD_BATCH_CLASS" },
  { name: "/batch-classes/edit", action: "EDIT_BATCH_CLASS" },
  { name: "/batch-classes/view", action: "VIEW_BATCH_CLASS||VIEW_SELF_BATCH_CLASSES" },
  { name: "/batch-classes/delete", action: "DELETE_BATCH_CLASS" },

  { name: "/class-records", action: "VIEW_BATCH_CLASS_RECORD||VIEW_SELF_BATCH_CLASS_RECORDS" },
  { name: "/class-records/add", action: "ADD_BATCH_CLASS_RECORD" },
  { name: "/class-records/edit", action: "EDIT_BATCH_CLASS_RECORD" },
  { name: "/class-records/view", action: "VIEW_BATCH_CLASS_RECORD||VIEW_SELF_BATCH_CLASS_RECORDS" },
  { name: "/class-records/delete", action: "DELETE_BATCH_CLASS_RECORD" },

  // workshift assignments 
  { name: "/batch-students", action: "VIEW_BATCH_STUDENTS||VIEW_SELF_BATCH_STUDENTS" },
  { name: "/batch-students/add", action: "ADD_BATCH_STUDENT" },
  { name: "/batch-students/edit", action: "EDIT_BATCH_STUDENTS" },
  { name: "/batch-students/view", action: "VIEW_BATCH_STUDENTS||VIEW_SELF_BATCH_STUDENTS" },
  { name: "/batch-students/delete", action: "DELETE_BATCH_STUDENTS" },

  // rotation days
  { name: "/recruitment-agencies", action: "VIEW_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/add", action: "ADD_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/edit", action: "EDIT_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/view", action: "VIEW_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/delete", action: "DELETE_RECRUITMENT_AGENCIES" },

  // shift rotation assignment
  { name: "/companies", action: "VIEW_COMPANIES" },
  { name: "/companies/add", action: "ADD_COMPANIES" },
  { name: "/companies/edit", action: "EDIT_COMPANIES" },
  { name: "/companies/view", action: "VIEW_COMPANIES" },
  { name: "/companies/delete", action: "DELETE_COMPANIES" },

  // attendance time logs
  { name: "/admissions", action: "VIEW_ADMISSIONS" },
  { name: "/admissions/add", action: "ADD_ADMISSION" },
  { name: "/admissions/edit", action: "EDIT_ADMISSION" },
  { name: "/admissions/view", action: "VIEW_ADMISSIONS" },
  { name: "/admissions/delete", action: "DELETE_ADMISSION" },

  // attendance records
  { name: "/fee-installments", action: "VIEW_FEE_INSTALLMENTS" },
  { name: "/fee-installments/add", action: "ADD_FEE_INSTALLMENT" },
  { name: "/fee-installments/edit", action: "EDIT_FEE_INSTALLMENT" },
  { name: "/fee-installments/view", action: "VIEW_FEE_INSTALLMENTS" },
  { name: "/fee-installments/delete", action: "DELETE_FEE_INSTALLMENT" },

  // holiday calendar
  { name: "/classes-attendance", action: "VIEW_CLASS_ATTENDANCES||VIEW_SELF_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/add", action: "ADD_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/edit", action: "EDIT_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/view", action: "VIEW_CLASS_ATTENDANCES||VIEW_SELF_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/delete", action: "DELETE_CLASS_ATTENDANCE" },

  // employee leaves 
  { name: "/placement-referrals", action: "VIEW_PLACEMENT_REFERRALS" },
  { name: "/placement-referrals/add", action: "ADD_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/edit", action: "EDIT_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/view", action: "VIEW_PLACEMENT_REFERRALS" },
  { name: "/placement-referrals/delete", action: "DELETE_PLACEMENT_REFERRAL" },

  { name: "/student-review-platforms", action: "View_Review_Platform" },
  { name: "/student-review-platforms/add", action: "Add_Review_Platform" },
  { name: "/student-review-platforms/edit", action: "Edit_Review_Platform" },
  { name: "/student-review-platforms/view", action: "View_Review_Platform" },
  { name: "/student-review-platforms/delete", action: "Delete_Review_Platform" },

  { name: "/student-reviews", action: "View_Student_Review" },
  { name: "/student-reviews/add", action: "Add_Student_Review" },
  { name: "/student-reviews/edit", action: "Edit_Student_Review" },
  { name: "/student-reviews/view", action: "View_Student_Review" },
  { name: "/student-reviews/delete", action: "Delete_Student_Review" },

  // employee entitlments
  { name: "/demo-sessions", action: "VIEW_DEMO_SESSIONS||VIEW_SELF_DEMO_SESSIONS" },
  { name: "/demo-sessions/add", action: "ADD_DEMO_SESSION" },
  { name: "/demo-sessions/edit", action: "EDIT_DEMO_SESSION" },
  { name: "/demo-sessions/view", action: "VIEW_DEMO_SESSIONS||VIEW_SELF_DEMO_SESSIONS" },
  { name: "/demo-sessions/delete", action: "DELETE_DEMO_SESSION" },

  { name: "/demo-participants", action: "VIEW_DEMO_PARTICIPANTS||VIEW_SELF_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/add", action: "ADD_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/edit", action: "EDIT_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/view", action: "VIEW_DEMO_PARTICIPANTS||VIEW_SELF_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/delete", action: "DELETE_DEMO_PARTICIPANTS" },

// copy  employee 
  { name: "/certificates", action: "VIEW_CERTIFICATES" },
  { name: "/certificates/add", action: "ADD_CERTIFICATE" },
  { name: "/certificates/edit", action: "EDIT_CERTIFICATE" },
  { name: "/certificates/view", action: "VIEW_CERTIFICATES" },
  { name: "/certificates/delete", action: "DELETE_CERTIFICATE" },

 
  // change password

  { name: "/settings/change-password", action: "USER_RESET_PASSWORD" },

];

/**
 * True if user Permission array includes the action (supports "A||B" in route config).
 */
export function checkPermission(permissionList, action) {
  if (permissionList == null || !Array.isArray(permissionList) || !action) {
    return false;
  }
  const tokens = String(action)
    .split("||")
    .map((x) => String(x).trim().toUpperCase())
    .filter(Boolean);
  if (!tokens.length) return false;
  return tokens.some((token) =>
    permissionList.some((p) => String(p).trim().toUpperCase() === token)
  );
}

/**
 * Get permission action names for a module (list/form) by base path.
 * Use with usePermissionDataStore: Permission.includes(actions.add) etc.
 *
 * list: action required to see the list page (e.g. VIEW_LEADS). Used as fallback
 *       for View button so "can see list" => can open view single record.
 * Delete: If a "/delete" route exists (e.g. DELETE_LEAD), the Delete button
 * is shown only when the backend returns that action. If no "/delete" route
 * is defined, delete falls back to the edit action (can edit = can delete).
 *
 * @param {string} basePath - e.g. "/leads", "/lead-stages"
 * @returns {{ add?: string, edit?: string, view?: string, delete?: string, list?: string }}
 */
export function getModuleActions(basePath) {
  if (!basePath) return {};
  const normalized = basePath.replace(/\/$/, "");
  const list = routes.find((r) => r.name === normalized)?.action;
  const add = routes.find((r) => r.name === `${normalized}/add`)?.action;
  const edit = routes.find((r) => r.name === `${normalized}/edit`)?.action;
  const view = routes.find((r) => r.name === `${normalized}/view`)?.action;
  const del = routes.find((r) => r.name === `${normalized}/delete`)?.action;
  const hasDeleteRoute = routes.some((r) => r.name === `${normalized}/delete`);
  return {
    list,
    add,
    edit,
    view,
    // Modules with an explicit /delete route require that permission only (e.g. DELETE_DEMO_SESSION).
    delete: hasDeleteRoute ? del : del || edit,
  };
}
